import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
	palette: {
		type: 'light',
		primary: {
			main: '#0D2840',
		},
		secondary: {
			main: '#165F8C',
		},
		text: {
			primary: '#0A1926',
			secondary: '#0F2859',
			disabled: '#145E8C',
			hint: '#127CA6',
		},
		warning: {
			main: '#F9912B',
		},
		error: {
			main: '#F46161',
		},
		success: {
			main: '#049DD9',
		},
		divider: '#383F40',
		info: {
			main: '#B2D6ED',
		},
	},
	typography: {
		fontSize: 14,
		htmlFontSize: 17,
		fontFamily: "Poppins"
	},
});

export default theme;